import dayjs from "dayjs";
import { enmConfirmationStatus } from "../models/enums/ConfirmationStatus";
import { enmReservationStatus } from "../models/enums/ReservationStatus";
import { enmReservationType } from "../models/enums/ReservationType";
import { enmCurrency } from "../models/enums/Currency";
import { enmPriceType } from "../models/enums/PriceType";

export enum enmExcelExportType {
    ResMon = 1,
    ActionReport = 2,
    Board = 3,
    Market = 4,
    NotConfirmed = 5,
    RoomType = 6,
    EntryList = 7,
    AccommodationType = 8,
    RoomCapacity = 9
}

export type mdlColumnItem = {
    name: string;
    label: string;
    renderBefore?: (value: any) => string;
}

export type mdlColumnChildItem = {
    selector: string;
    columns: mdlColumnItem[];
    orderColumn?: string;
}

export type mdlExcelColumnMappingItem = {
    type: enmExcelExportType,
    columns: mdlColumnItem[];
    columnChilds?: mdlColumnChildItem[] | null;
}

export const ExcelColumnMappings: Array<mdlExcelColumnMappingItem> = [
    {
        type: enmExcelExportType.ResMon,
        columns: [
            {
                name: "confirmationStatus",
                label: "Confirmation Status",
                renderBefore: (value: enmConfirmationStatus) => {
                    switch (value) {
                        case enmConfirmationStatus.No:
                            return "No"
                        case enmConfirmationStatus.Yes:
                            return "Yes"
                        default:
                            return "Wait"
                    }
                }
            },
            {
                name: "reservationType",
                label: "Reservation Type",
                renderBefore: (value: enmReservationType) => {
                    switch (value) {
                        case enmReservationType.Cancelled:
                            return "Cancelled"
                        case enmReservationType.Changed:
                            return "Changed"
                        case enmReservationType.New:
                            return "New"
                    }
                }
            },
            {
                name: "reservationStatus",
                label: "Reservation Status",
                renderBefore: (value: enmReservationStatus) => {
                    switch (value) {
                        case enmReservationStatus.GoShow:
                            return "Go Show"
                        case enmReservationStatus.NoShow:
                            return "No Show"
                        case enmReservationStatus.OnRequest:
                            return "On Request"
                        case enmReservationStatus.Option:
                            return "Option"
                        case enmReservationStatus.Ok:
                            return "OK"
                    }
                },
            },
            {
                name: "hotelName",
                label: "Hotel Name",
            },
            {
                name: "sejHotelName",
                label: "Sejour Hotel Name",
            },
            {
                name: "agency",
                label: "Agency Name",
            },
            {
                name: "voucherNo",
                label: "Voucher",
            },
            {
                name: "sellDate",
                label: "Sell Date",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "checkIn",
                label: "Check In",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "checkOut",
                label: "Check Out",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "nights",
                label: "Night"
            },
            {
                name: "roomName",
                label: "Room Name"
            },
            {
                name: "roomTypeName",
                label: "Room Type"
            },
            {
                name: "Board",
                label: "accomName"
            },
            {
                name: "roomCount",
                label: "Total Room"
            },
            {
                name: "soldPriceString",
                label: "Price"
            },
            {
                name: "soldCurrency",
                label: "Currency"
            },
            {
                name: "adults",
                label: "Adults  "
            },
            {
                name: "childs",
                label: "Child"
            },
            {
                name: "infants",
                label: "Infant"
            },
            {
                name: "infants",
                label: "Infant"
            },
            {
                name: "pax",
                label: "Total Pax"
            },
            {
                name: "_customers",
                label: "Customers"
            },
            {
                name: "_note",
                label: "Note"
            }
        ],
        columnChilds: [
            {
                selector: "_customers",
                columns: [
                    {
                        name: "sequence",
                        label: "#"
                    },
                    {
                        name: "title",
                        label: "Title"
                    },
                    {
                        name: "name",
                        label: "Name Surname"
                    },
                    {
                        name: "age",
                        label: "Age"
                    },
                    {
                        name: "birthDateString",
                        label: "Birth Date"
                    },
                    {
                        name: "nationalityString",
                        label: "Nationality"
                    },
                    {
                        name: "arrival",
                        label: "Arr. Flight"
                    },
                    {
                        name: "departure",
                        label: "Dep. Flight"
                    }
                ],
                orderColumn: "sequence"
            },
            {
                selector: "_note",
                columns: [
                    {
                        name: "note",
                        label: "# Agency Note"
                    }
                ],
            }
        ]
    },
    {
        type: enmExcelExportType.EntryList,
        columns: [
            {
                name: "operator",
                label: "Operator",
            },
            {
                name: "confirmationStatus",
                label: "Confirmation Status",
                renderBefore: (value: enmConfirmationStatus) => {
                    switch (value) {
                        case enmConfirmationStatus.No:
                            return "No"
                        case enmConfirmationStatus.Yes:
                            return "Yes"
                        default:
                            return "Wait"
                    }
                }
            },
            {
                name: "hotelName",
                label: "Hotel"
            },
            {
                name: "voucher",
                label: "Voucher No"
            },
            {
                name: "title",
                label: "Title",
            },
            {
                name: "name",
                label: "Name"
            },
            {
                name: "nationalityString",
                label: "Nationality"
            },
            {
                name: "arrivalYon1",
                label: "Arrival"
            },
            {
                name: "arrivalTimeString",
                label: "Arrival Date"
            },
            {
                name: "departureYon1",
                label: "Departure"
            },
            {
                name: "departureTimeString",
                label: "Departure Date"
            },
            {
                name: "checkInDate",
                label: "Check In",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "checkOutDate",
                label: "Check Out",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            }
        ],
        columnChilds: null
    },
    {
        type: enmExcelExportType.ActionReport,
        columns: [
            {
                name: "hotelName",
                label: "Hotel Name"
            },
            {
                name: "agencyName",
                label: "Agency Name"
            },
            {
                name: "roomType",
                label: "Room Type"
            },
            {
                name: "priceType",
                label: "Price Type",
                renderBefore: (value: enmPriceType) => {
                    switch (value) {
                        case enmPriceType.PER_PERSON:
                            return "Per Person";
                        case enmPriceType.PER_ROOM:
                            return "Per Room";
                    }
                }
            },
            {
                name: "sentDate",
                label: "Sent Date",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "sellStartDate",
                label: "Sell Start Date",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "sellEndDate",
                label: "Sell End Date",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "accomStartDate",
                label: "Accom Start Date",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "accomEndDate",
                label: "Accom End Date",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "price",
                label: "Price"
            },
            {
                name: "currency",
                label: "Currency",
                renderBefore: (value: enmCurrency) => {
                    switch (value) {
                        case enmCurrency.USD:
                            return "USD";
                        case enmCurrency.EURO:
                            return "EUR";
                        case enmCurrency.TL:
                            return "TL";
                        case enmCurrency.GBP:
                            return "GBP";
                    }
                }
            },
            {
                name: "sender",
                label: "Sender"
            },
        ],
        columnChilds: null
    },
    {
        type: enmExcelExportType.Market,
        columns: [
            {
                name: "name",
                label: "Market Name"
            },
            {
                name: "isPublished",
                label: "Publish Status",
                renderBefore: (value: boolean) => {
                    return value ? "Published" : "Draft";
                }
            },
        ],
        columnChilds: null
    },
    {
        type: enmExcelExportType.RoomType,
        columns: [
            {
                name: "code",
                label: "Code"
            },
            {
                name: "name",
                label: "Name"
            }
        ],
        columnChilds: null
    },
    {
        type: enmExcelExportType.AccommodationType,
        columns: [
            {
                name: "code",
                label: "Code"
            },
            {
                name: "name",
                label: "Name"
            }
        ],
        columnChilds: null
    },
    {
        type: enmExcelExportType.RoomCapacity,
        columns: [
            {
                name: "roomCode",
                label: "Room Code"
            },
            {
                name: "roomName",
                label: "Room Name"
            },
            {
                name: "roomTypeCode",
                label: "Room Type Code"
            },
            {
                name: "roomTypeName",
                label: "Room Type Name"
            },
            {
                name: "adults",
                label: "Adults"
            },
            {
                name: "maxAdults",
                label: "Max Adults"
            },
            {
                name: "minAdults",
                label: "Min Adults"
            },
            {
                name: "maxChilds",
                label: "Max Adults"
            },
            {
                name: "maxPax",
                label: "Max Pax"
            },
            {
                name: "starts",
                label: "Starts",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            {
                name: "ends",
                label: "Ends",
                renderBefore: (value: string) => {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
        ],
        columnChilds: null
    },
    {
        type: enmExcelExportType.NotConfirmed,
        columns: [
            {
                name: "code",
                label: "Code"
            },
            {
                name: "name",
                label: "Name"
            }
        ],
    },
    {
        type: enmExcelExportType.Board,
        columns: [
            {
                name: "code",
                label: "Code"
            },
            {
                name: "name",
                label: "Name"
            }
        ],
    }
]
